import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Undo, Redo, Save } from "@mui/icons-material";

interface EditSectionFooterProps {
  enableEditing: boolean;
  lastModifiedTime: Date | null;
  isSaving: boolean;
  canUndo: boolean;
  canRedo: boolean;
  onUndo: () => void;
  onRedo: () => void;
  onInstantSave: () => void;
  onSaveAndExit: () => void;
}

export const EditSectionFooter: React.FC<EditSectionFooterProps> = ({
  enableEditing,
  lastModifiedTime,
  isSaving,
  canUndo,
  canRedo,
  onUndo,
  onRedo,
  onInstantSave,
  onSaveAndExit,
}) => {
  if (!enableEditing) return null;

  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      justifyContent="center"
      alignItems="center"
      gap={2}
      flexWrap="wrap"
      sx={{ width: "100%", py: 0.5 }}
    >
      <Typography variant="body2" color="text.secondary" noWrap>
        Last saved:{" "}
        <Box component="span" fontWeight="bold" color="text.primary">
          {lastModifiedTime && new Date(lastModifiedTime).toLocaleString()}
        </Box>
      </Typography>
      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent="flex-end"
        alignItems="center"
        gap={1}
      >
        <Button
          variant="outlined"
          size="small"
          startIcon={<Undo />}
          disabled={!canUndo}
          onClick={onUndo}
        >
          Undo
        </Button>
        <Button
          variant="outlined"
          size="small"
          startIcon={<Redo />}
          disabled={!canRedo}
          onClick={onRedo}
        >
          Redo
        </Button>
        <Button
          disabled={isSaving}
          loading={isSaving}
          variant="contained"
          size="small"
          startIcon={<Save />}
          onClick={onInstantSave}
        >
          Save
        </Button>
        <Button
          disabled={isSaving}
          loading={isSaving}
          variant="outlined"
          size="small"
          startIcon={<Save />}
          onClick={onSaveAndExit}
        >
          Save & Exit
        </Button>
      </Box>
    </Box>
  );
};
